export interface MarketDefinition {
  symbol: string;
  precision: number;
  icon: string;
  bitgetSymbol?: string;
}

export const PLATFORM_COIN: MarketDefinition = Object.freeze({
  symbol: "GOP",
  precision: 2,
  icon: "/market-icons/platform.png",
});

const liveMarkets: MarketDefinition[] = [
  { symbol: "BTC", precision: 2, icon: "/market-icons/btc.webp", bitgetSymbol: "BTCUSDT" },
  { symbol: "ETH", precision: 2, icon: "/market-icons/eth.webp", bitgetSymbol: "ETHUSDT" },
  { symbol: "BNB", precision: 2, icon: "/market-icons/bnb.webp", bitgetSymbol: "BNBUSDT" },
  { symbol: "LTC", precision: 2, icon: "/market-icons/ltc.webp", bitgetSymbol: "LTCUSDT" },
  { symbol: "FIL", precision: 2, icon: "/market-icons/fil.webp", bitgetSymbol: "FILUSDT" },
  { symbol: "XRP", precision: 4, icon: "/market-icons/xrp.webp", bitgetSymbol: "XRPUSDT" },
  { symbol: "SOL", precision: 2, icon: "/market-icons/sol.webp", bitgetSymbol: "SOLUSDT" },
  { symbol: "ADA", precision: 4, icon: "/market-icons/ada.webp", bitgetSymbol: "ADAUSDT" },
  { symbol: "DOGE", precision: 4, icon: "/market-icons/doge.webp", bitgetSymbol: "DOGEUSDT" },
];

export const HOME_MARKETS: ReadonlyArray<MarketDefinition> = Object.freeze([
  liveMarkets[0],
  liveMarkets[1],
  PLATFORM_COIN,
  ...liveMarkets.slice(2),
]);
